( function() {
	if( typeof window.SYR == 'undefined' ) { window.SYR = {}; }

	window.SYR.SiteFilter = function () {

		var _targetId = 0,
			_userStageId = 0,
			_supporterStageId = 0,
			_substances = [],
			_ages = [],
			_genders = [];

		// Converts the string representation of a comma-separated list into an array of integers.
		function extract( str ) {
			var list = str.split( ',' ),
				result = [],
				value;

			list.forEach( function ( val ) {
				value = parseInt( val );
				if ( !isNaN( value ) ) {
					result.push( value );
				}
			} );

			return result;
		}

		function load() {
			var cookie = window.SYR.readCookie( window.SYR.SITE_FILTER_COOKIE ) || '',
				parts = cookie.split( '|' ),
				ids;

			if( parts.length > 0 ) {
				ids = extract( parts[0] );
				if( ids.length > 0 ) { setTarget( ids[0] ); }
				if( ids.length > 1 ) { setUserStage( ids[1] ); }
				if( ids.length > 2 ) { setSupporterStage( ids[2] ); }
			}

			if ( parts.length > 1 ) {
				setSubstances( extract( parts[1] ) );
			}
			if ( parts.length > 2 ) {
				setAges( extract( parts[2] ) );
			}
			if ( parts.length > 3 ) {
				setGenders( extract( parts[3] ) );
			}
		}

		function reset() {
			_targetId = _userStageId = _supporterStageId = 0;
			_substances = [];
			_ages = [];
			_genders = [];

			window.SYR.createCookie( window.SYR.HOME_PAGE_COOKIE, '/' );
			save();
		}

		function toString( targetAndStage ) {
			if ( !targetAndStage ) {
				targetAndStage = _targetId + ',' + _userStageId + ',' + _supporterStageId;
			}

			return targetAndStage + '|' + _substances.join( ',' ) + '|' + _ages.join( ',' ) + '|' + _genders.join( ',' );
		}

		function save() {
			var value = toString();
			window.SYR.createCookie( window.SYR.SITE_FILTER_COOKIE, value );
		}

		function dump() {
			/* eslint-disable no-console */
			console.info( 'TargetId:         ' + _targetId );
			console.info( 'UserStageId:      ' + _userStageId );
			console.info( 'SupporterStageId: ' + _supporterStageId );

			if ( _substances.length ) {
				console.info( 'Substances: ' + _substances.join( ', ' ) );
			}

			if ( _ages.length ) {
				console.info( 'Ages: ' + _ages.join( ', ' ) );
			}

			if ( _genders.length ) {
				console.info( 'Genders: ' + _genders.join( ', ' ) );
			}
			/* eslint-enable no-console */
		}

		//// Set local variables

		function setTarget( id ) {
			_targetId = id;
		}

		function setUserStage( id ) {
			_userStageId = id;
		}

		function setSupporterStage( id ) {
			_supporterStageId = id;
		}

		function setSubstances( values ) {
			if ( values && values.length ) {
				_substances = values;
			} else {
				_substances = [];
			}
		}

		function setAges( values ) {
			if ( values && values.length ) {
				_ages = values;
			} else {
				_ages = [];
			}
		}

		function setGenders( values ) {
			if ( values && values.length ) {
				_genders = values;
			} else {
				_genders = [];
			}
		}

		return {
			load: load,
			save: save,
			dump: dump,
			reset: reset,
			toString: toString,

			/* Returns true if any customization of substances, ages and/or gender */
			isCustomized: function() { 
				return _substances.length || _ages.length || _genders.length;
			},
					
			getTarget: function () { return _targetId; },
			setTarget: setTarget,

			getUserStage: function () { return _userStageId; },
			setUserStage: setUserStage,

			getSupporterStage: function () { return _supporterStageId; },
			setSupporterStage: setSupporterStage,

			getSubstances: function () { return _substances; },
			setSubstances: setSubstances,

			getAges: function () { return _ages; },
			setAges: setAges,

			getGenders: function () { return _genders; },
			setGenders: setGenders
		};
	}();
} )();